/* eslint-disable react/require-default-props */
import BlogPostStructure from './propTypes'
import template from './template.rt'

import './styles.css'

function BlogPost(props) {
  return template.call({ props })
}

BlogPost.propTypes = BlogPostStructure

BlogPost.defaultProps = {
  description: '',
  elementName: 'posts-0'
}

export default BlogPost
